import { useCallback, useState } from 'react';
import Audiences from '../components/Audiences';
import Categories from '../components/Categories';
import Cta from '../components/Cta';
import Faq from '../components/Faq';
import Hero from '../components/Hero';
import Marketing from '../components/Marketing';
import Pillars from '../components/Pillars';
import Pricing from '../components/Pricing';
import Products from '../components/Products';
import Steps from '../components/Steps';
import Why from '../components/Why';

export default function HomePage() {
  const [toast, setToast] = useState('');

  const onSelect = useCallback((product) => {
    setToast(`${product.name} selected — continue to pricing when ready.`);
    window.setTimeout(() => setToast(''), 2800);
  }, []);

  return (
    <>
      <Hero />
      <Pillars />
      <Categories />
      <Products onSelect={onSelect} />
      <Marketing />
      <Audiences />
      <Why />
      <Steps />
      <Pricing />
      <Faq />
      <Cta />
      <div
        className={`fm-toast${toast ? ' is-visible' : ''}`}
        role="status"
        aria-live="polite"
      >
        {toast}
      </div>
    </>
  );
}
